import React, {PropsWithChildren} from 'react';
import {BooleanInputProps} from '../shared/props';
import * as css from './RsnCheckbox.css';

function RsnCheckbox({className = '', inputRef, ...props}: BooleanInputProps) {
    return <input {...props} ref={inputRef} type='checkbox' className={`${className} ${css.input}`} />;
}

export const Labeled = ({children, className = '', ...rest}: PropsWithChildren<BooleanInputProps>) => {
    return (
        <label className={`${className} ${css.labelContainer}`}>
            <RsnCheckbox {...rest} />
            <span className={css.labelText}>{children}</span>
        </label>
    );
};
Labeled.displayName = 'RsnCheckbox.Labeled';

RsnCheckbox.Labeled = Labeled;

export default RsnCheckbox;
